import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';
import { a as angleRight } from '../LocalModules/storm-ui-icons/dist/esm/classicIcons-CHpXglL2-uH6-91Kn.js';
import { T as TextButton } from '../Button/TextButton/TextButton-CNxSWTyU.js';
import { I as Icon } from '../Icon/Icon-CoM8rI0H.js';

const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40026394__sc-tb9hgd-0"
})(["color:", ";padding-inline-end:", ";", " && > svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}", "}[dir=\"rtl\"] && > svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}/*! @noflip */ transform:rotate(180deg);", "}"], ({
  theme
}) => theme.icon.color.default, ({
  theme
}) => theme.spacing.xxsmall.default, isMobile(css(["padding-inline-end:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile)), ({
  $opened,
  $inline
}) => {
  if ($opened) {
    if ($inline) {
      return css(["/*! @noflip */ transform:rotate(90deg);"]);
    }
    return css(["/*! @noflip */ transform:rotate(-90deg);"]);
  }
  return '';
}, ({
  $opened,
  $inline
}) => {
  if ($opened) {
    if ($inline) {
      return css(["/*! @noflip */ transform:rotate(90deg);"]);
    }
    return css(["/*! @noflip */ transform:rotate(270deg);"]);
  }
  return '';
});
const StyledButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-40026394__sc-tb9hgd-1"
})(["display:inline-flex;justify-content:flex-start;align-items:center;"]);
const TextButtonLabel = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-tb9hgd-2"
})(["flex:1 1 auto;"]);
const ExtenderContent = /*#__PURE__*/styled('section').withConfig({
  componentId: "sc-storm-ui-40026394__sc-tb9hgd-3"
})(["display:", ";margin-block-end:", ";", ""], ({
  isOpen
}) => isOpen ? 'block' : 'none', ({
  theme
}) => theme.spacing.xxxsmall.default, isMobile(css(["margin-block-end:", ";"], ({
  theme
}) => theme.spacing.xxxsmall.mobile)));
const ExtenderButton = ({
  onClick,
  isOpen,
  label,
  inline,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, restProps, {
  onClick: onClick,
  tabIndex: 0,
  "aria-expanded": isOpen
}), /*#__PURE__*/React__default.createElement(StyledIcon, {
  type: angleRight,
  size: "small",
  $opened: isOpen,
  $inline: inline
}), /*#__PURE__*/React__default.createElement(TextButtonLabel, null, label));
const Extender = ({
  children,
  handleClick = noop,
  isOpen,
  label,
  triggerProps = {},
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('extender')
}, /*#__PURE__*/React__default.createElement(ExtenderContent, _extends({}, rest, {
  isOpen: isOpen
}), children), /*#__PURE__*/React__default.createElement(ExtenderButton, _extends({
  taktId: createStormTaktId(isOpen ? 'close-button' : 'open-button')
}, triggerProps, {
  onClick: handleClick,
  isOpen: isOpen,
  label: label
})));

export { ExtenderButton as E, Extender as a };
//# sourceMappingURL=Extender-DnqZaLPo.js.map
